import { create } from "zustand";

interface RmsRefreshStore {
  /** True when a websocket notification indicates new data is available */
  hasNewData: boolean;
  /** Mark that new data is available (called from websocket handler) */
  markNewData: () => void;
  /** Clear the indicator (called when user clicks refresh) */
  clearNewData: () => void;
}

const useRmsRefreshStore = create<RmsRefreshStore>((set) => ({
  hasNewData: false,
  markNewData: () => set({ hasNewData: true }),
  clearNewData: () => set({ hasNewData: false }),
}));

export default useRmsRefreshStore;
